import block from './block.json';

export const cardArtistThemeAttributes = {
	name: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.heading-4',
		textAlignment: 'left',
	},
	role: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.fresco-s',
		textAlignment: 'left',
	},
	link: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.button',
		textAlignment: 'left',
	},
	bio: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.small-text',
		textAlignment: 'left',
	},
	states: {
		hover: {}, // adds hover state
	},
};

export const CardArtistThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: cardArtistThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
